/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import EmailAPI from '@/api/EmailAPI.js';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { NumberRetry, NumberTimeOutRetry } from '@/api/base/base-api';
import { MSEnum } from '@/common/enumeration';

export default {
	loadEmail: async function(context, payload) {
		const me = this;
		// reset lại số lượng email mới
		if (payload.skip == 0) {
			context.commit('resetTotalEmailWaiting');
			//Khi load trang đầu tiên thì gọi lấy số lượng email
			context.dispatch('getEmailTotalCount', payload);
		}
		let res = await httpClient.getAsync(
			{
				url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
				params: payload
			},
			true,
			false
		);
		if (res && res.Success) {
			// Email xóa
			if (payload.type == 1) {
				if (payload.pageAppend) {
					context.commit('appendEmailTrashList', res.Data);
				} else {
					context.commit('updateEmailTrashList', res.Data);
				}
			}
			// Email spam
			else if (payload.type == 3) {
				if (payload.pageAppend) {
					context.commit('appendEmailSpamList', res.Data);
				} else {
					context.commit('updateEmailSpamList', res.Data);
				}
			}
			// Hộp thư và quan trọng
			else {
				if (payload.pageAppend) {
					context.commit('appendEmailList', res.Data);
				} else {
					context.commit('updateEmailList', res.Data);
				}
			}
			return res.Data.Data;
		}
		return null;
	},
	getEmailTotalCount: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/total`,
			params: payload
		});
		if (res && res.Success) {
			// Email xóa
			if (payload.type == 1) {
				context.commit('updateTrashEmailTotal', res.Data);
			}
			// Email spam
			else if (payload.type == 3) {
				context.commit('updateSpamEmailTotal', res.Data);
			}
			// Hộp thư và quan trọng
			else {
				context.commit('updateEmailTotal', res.Data);
			}
			return res.Data;
		}
	},
	loadContentEmailByID: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/content/${payload.Id}`
		});
		if (res && res.Success) {
			return res.Data;
		}
		return null;
	},
	loadEmailByID: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${payload}`
		});
		return res && res.Success ? res.Data : null;
	},
	// Cho email vào thùng rác
	deleteEmailById: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/trash/${payload}`
		});
		if (res && res.Success) {
			context.commit('updateListEmailByDelete', payload);
			return res.Data;
		}
		return null;
	},
	// Cho email vào thùng rác
	deleteManyEmail: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/trash`,
			data: payload
		});
		if (res && res.Success) {
			context.commit('updateListEmailByDelete', payload);
			return res.Data;
		}
		return null;
	},
	// Báo cáo là email spam
	spamManyEmail: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/spam`,
				data: payload
			},
			true
		);
		if (res && res.Success) {
			context.commit('updateEmailSpam', payload);
			return res.Data;
		}
		return null;
	},
	// Chuyển về hộp thư
	moveEmailToInbox: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/inbox/${payload}`
		});
		if (res && res.Success) {
			context.commit('updateListSpamEmailByDelete', payload);
			return res.Data;
		}
		return null;
	},
	// Xóa vĩnh viễn email
	deleteForeverEmailById: async function(context, payload) {
		let res = await httpClient.deleteAsync(
			{
				url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${payload}`
			},
			true,
			false
		);
		if (res && res.Success) {
			context.commit('updateListSpamEmailByDelete', payload);
			return res.Data;
		}
		return null;
	},
	deleteManySpamEmail: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/delete`,
				data: payload
			},
			true,
			false
		);
		if (res && res.Success) {
			context.commit('updateListSpamEmailByDelete1', payload);
			return res.Data;
		}
		return null;
	},
	/**
	 * Tải file đính kèm ở email
	 */
	getFileAttachment: async function(context, payload) {
		let param = {
			Id: payload.Id
		};
		let ProgressData = {
			percentCompleted: 0,
			fileName: payload.FileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.getAsync({
			url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/download/${payload.EmailId}`,
			params: param,
			responseType: 'arraybuffer',
			onDownloadProgress: function(progressEvent) {
				var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
				if (progressEvent.loaded > progressEvent.total) {
					percentCompleted = 100;
				}
				ProgressData = {
					percentCompleted: percentCompleted,
					fileName: payload.FileName,
					Success: true
				};
				EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			}
		});
		if (res) {
			if (res instanceof ArrayBuffer) {
				commonFunc.downloadByBlob(res, payload.ContentType, payload.FileName);
			} else {
				ProgressData = {
					percentCompleted: 0,
					fileName: payload.FileName,
					Success: false
				};
				EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			}
			return res;
		}
		return null;
	},

	/**
	 * Tải tất cả file đính kèm của email
	 */
	getAllAttachmentZip: async function(context, payload) {
		let ProgressData = {
			percentCompleted: 0,
			fileName: `${payload.FileName}.zip`,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.postAsync({
			url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/zip/${payload.EmailId}`
		});
		if (res && res.Success) {
			let tryTime = 0;
			async function download(key) {
				tryTime++;
				let downloaded = await httpClient.getAsync({
					url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/downloadall/${key}`,
					responseType: 'arraybuffer'
				});
				if (downloaded instanceof ArrayBuffer) {
					ProgressData = {
						percentCompleted: 100,
						fileName: `${payload.FileName}.zip`,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					commonFunc.downloadByBlob(downloaded, 'application/zip', `${payload.FileName}.zip`);
				} else {
					if (tryTime >= NumberRetry) {
						ProgressData = {
							percentCompleted: 0,
							fileName: `${payload.FileName}.zip`,
							Success: false
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						return;
					}
					setTimeout(() => {
						download(key);
					}, NumberTimeOutRetry);
				}
			}
			setTimeout(() => {
				download(res.Data.Key);
			}, NumberTimeOutRetry);
			return res;
		} else {
			ProgressData = {
				percentCompleted: 0,
				fileName: `${payload.FileName}.zip`,
				Success: false
			};
			EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			return null;
		}
	},
	/// forward mail
	forwardMail: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/sendmail`,
				data: payload
			},
			true
		);
		return res;
	},
	// Đánh dấu thư quan trọng
	bookmarkStarEmail: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/important`,
			data: payload
		});
		if (res && res.Success) {
			return res.Data;
		}
		return null;
	},
	updateReadEmailAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/read/${payload.EmailId}`,
			params: payload
		});
		if (res && res.Success) {
			if (payload && payload.ComponentName == 'Inbox') {
				context.commit('updateNotReadEmailList1', -1);
			}
			return res.Data;
		}
	},
	loadTotalEmailNoRead: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/total-noread`
		});
		if (res && res.Success) {
			context.commit('updateNotReadEmailList', res.Data);
			return res.Data;
		}
	},
	/**
	 * Kiểm tra lại email
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	checkAgainEmailAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/checkagain/${payload.EmailId}`
		});
		if (res && res.Success) {
			return res.Data;
		}
	},
	/**
	 * Đánh dấu email chưa đọc
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	updateUnReadEmailAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/unread/${payload.EmailId}`,
			params: payload
		});
		if (res && res.Success) {
			context.commit('updateNotReadEmailList1', 1);
			return res.Data;
		}
	},
	/**
	 * Kiểm tra lại nhiều email
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	checkAgainMultiAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/checkagainmulti`,
			data: payload
		});
		if (res && res.Success) {
			return res.Data;
		}
	},

	/**
	 * Kiểm tra đơn vị đã từng có email nào chưa (không filter theo ngày)
	 */
	hasAnyEmail: async function(context) {
		let res = await httpClient.getAsync({
			url: EmailAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/has-any`
		});
		if (res && res.Success) {
			context.commit('updateHasAnyEmail', res.Data);
			return res.Data;
		}
		context.commit('updateHasAnyEmail', false);
		return false;
	}
};
